import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AppNav from '../../components/appNav';

export default function CheckoutExpired() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [paymentInfo, setPaymentInfo] = useState(null);

    useEffect(() => {
        // Captura parâmetros da URL retornados pela Asaas
        const externalReference = searchParams.get('externalReference');
        const paymentId = searchParams.get('id');

        if (externalReference || paymentId) {
            setPaymentInfo({
                externalReference,
                paymentId
            });
        }
    }, [searchParams]);

    const handleBackToEvents = () => {
        navigate('/');
    };

    const handleTryAgain = () => {
        // Volta para a página anterior (formulário de inscrição)
        navigate('/');
    };

    return (
        <>
            <AppNav />
            <Container maxWidth="md" sx={{ mt: 8, mb: 4 }}>
                <Paper 
                    elevation={3} 
                    sx={{ 
                        p: 4, 
                        textAlign: 'center',
                        borderRadius: 2
                    }}
                >
                    <ErrorOutlineIcon 
                        sx={{ 
                            fontSize: 80, 
                            color: 'error.main',
                            mb: 2 
                        }} 
                    />
                    
                    <Typography 
                        variant="h4" 
                        component="h1" 
                        gutterBottom
                        sx={{ fontWeight: 'bold', color: 'error.main' }}
                    >
                        Checkout Expirado
                    </Typography>

                    <Typography 
                        variant="body1" 
                        color="text.secondary" 
                        sx={{ mb: 3 }}
                    >
                        O tempo para completar o pagamento expirou. Sua inscrição foi cancelada. 
                    </Typography>

                    {paymentInfo && paymentInfo.externalReference && (
                        <Box 
                            sx={{ 
                                mt: 3, 
                                p: 2, 
                                bgcolor: 'grey.100', 
                                borderRadius: 1,
                                textAlign: 'left'
                            }}
                        >
                            <Typography variant="body2" gutterBottom>
                                <strong>Referência:</strong>
                            </Typography>
                            
                            <Typography variant="body2" color="text.secondary">
                                Código: {paymentInfo.externalReference}
                            </Typography>
                        </Box>
                    )}

                    <Typography 
                        variant="body2" 
                        color="text.secondary" 
                        sx={{ mt: 3, mb: 3 }}
                    >
                        Por favor, inicie um novo processo de inscrição para continuar.
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3 }}>
                        <Button 
                            variant="outlined" 
                            color="primary" 
                            size="large"
                            onClick={handleBackToEvents}
                        >
                            Voltar para Eventos
                        </Button>
                        
                        <Button 
                            variant="contained" 
                            color="primary" 
                            size="large"
                            onClick={handleTryAgain}
                        >
                            Nova Inscrição
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </>
    );
}
